import { FoodsSelect, FoodsSelectProps } from "@foodpilot/foods";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ScoreWithVariation } from "src/services/ScoreService";

type VariationSelectorProps = {
    value: ScoreWithVariation | null;
    variations: ScoreWithVariation[];
    onChange: (variation: ScoreWithVariation | null) => void;
    disableText?: boolean;
    BoxPropsOverride?: FoodsSelectProps<unknown>["BoxProps"];
};
export const VariationSelector = (props: VariationSelectorProps) => {
    const { variations, value, onChange, disableText = false, BoxPropsOverride = {} } = props;
    const { t } = useTranslation();

    if (variations === null || variations.length <= 1) return;

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
            }}
        >
            {disableText === false && (
                <Typography
                    variant="h5"
                    sx={{
                        whiteSpace: "nowrap",
                        display: { xs: "none", lg: "block" },
                    }}
                >
                    {t("company.overview.variations.display_by", "Display by:")}
                </Typography>
            )}
            <FoodsSelect
                selectedOption={value}
                options={variations}
                onChange={(selectedVariation) => {
                    onChange?.(selectedVariation);
                }}
                getId={(variation) => variation.variationId?.toString() ?? ""}
                getName={(variation) => variation.label}
                closeOnSelect
                disableSearch
                textOptions={{
                    placeholder: t("component.select.placeholder"),
                    searchPlaceholder: t("component.select.searchplaceholder"),
                    emptyOptionsText: t("component.select.nooptions"),
                    defaultValueText: t("component.select.defaultvalue"),
                    noResult: t("component.select.noresultfound"),
                }}
                BoxProps={BoxPropsOverride}
            />
        </Box>
    );
};
